import { render } from "./AssociationDetail.vue?vue&type=template&id=41cda1a5&scoped=true"
import script from "./AssociationDetail.vue?vue&type=script&lang=js"
export * from "./AssociationDetail.vue?vue&type=script&lang=js"

import "./AssociationDetail.vue?vue&type=style&index=0&id=41cda1a5&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cda1a5"]])

export default __exports__